export enum CampaignType {
	HYBRID_EBP = 'hybrid_ebp',
	FULL_EBP = 'full_ebp',
	RBP = 'rbp',
	FREE_TRIAL = 'free_trial',
	NRBP = 'nrbp',
	ADVANCED_NRBP = 'advanced_nrbp',
	BASIC = 'basic'
}
